import {z} from "zod";
import {ContentItem as ContentItemType} from "../ContentItem/Data";

export default z.object({
    layout: z.string().default('default'),
    content_layout: z.string(),
    type: z.enum(['search', 'stream']),
    //	passthrough: search filters and stream_id live inside config too
    config: z.object({
        limit: z.number(),
        offset: z.number().optional(),
        prevent_page_duplicates: z.boolean().default(true),
        stream_id: z.union([z.number(), z.string()]).optional(),
    }).passthrough(),
    content: z.object({
        total: z.number(),
        items: z.array(ContentItemType),
    }),
    content_custom_fields: z.record(z.any()).optional(),
    custom_fields: z.record(z.any()).optional()
});
